import Component from './Input'

export default Component
